import { Box } from "@chakra-ui/react"
import { SystemStyleObject } from "@chakra-ui/styled-system"

const CheckIcon = ({ sx }: { sx?: SystemStyleObject }): JSX.Element => (
  <Box sx={sx}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-check"
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  </Box>
)

export default CheckIcon
